<ng-container *ngIf="{ mitec: mitec$ | async } as vm">
  <ion-header class="ion-no-border">
    <ion-toolbar>
      <ion-title></ion-title>
      <ion-buttons slot="start">
        <ion-back-button defaultHref="/" color="light"></ion-back-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>

  <ion-content fullscreen class="ion-padding">
    <img src="/assets/imgs/logo-blanco.png" />
    <form [formGroup]="form">
      <ion-grid>
        <ion-row color="primary" class="ion-justify-content-center">
          <ion-col
            class="ion-align-self-center"
            size-md="6"
            size-lg="5"
            size-xs="12"
            *ngIf="driver || vm.mitec === false"
          >
            <div *ngIf="!driver">
              <ion-item>
                <ion-label position="floating">E-mail</ion-label>
                <ion-input name="email" type="email" formControlName="email"></ion-input>
              </ion-item>
              <p
                *ngIf="form.controls['email'] && form.controls['email'].errors && (form.controls['email'].dirty || form.controls['email'].touched)"
                class="danger ion-padding"
              >
                E-mail inválido.
              </p>
              <ion-item>
                <ion-label position="floating">Password</ion-label>
                <app-show-hide-password>
                  <ion-input name="password" type="password" formControlName="password"></ion-input>
                </app-show-hide-password>
              </ion-item>
              <p
                *ngIf="form.controls['password'] && form.controls['password'].errors && (form.controls['password'].dirty || form.controls['password'].touched)"
                class="danger ion-padding"
              >
                Password requerido.
              </p>

              <ion-item hidden>
                <ion-label>Campus</ion-label>
                <ion-select placeholder="Seleccionar" #mySelect (ionChange)="goTerms(mySelect.value)">
                  <ion-select-option value="1">Puebla</ion-select-option>
                  <ion-select-option value="3">CCM</ion-select-option>
                  <ion-select-option value="10">Santa Fe</ion-select-option>
                  <ion-select-option value="5">CEM</ion-select-option>
                  <ion-select-option value="6">CEM - Esmeralda</ion-select-option>
                  <ion-select-option value="9">Querétaro</ion-select-option>
                  <ion-select-option value="11">Guadalajara</ion-select-option>
                </ion-select>
              </ion-item>

              <ion-item class="terms">
                <ion-label>
                  Acepto*
                  <span style="text-decoration: underline" (click)="showCampus()">Términos y condiciones</span>
                  <br />
                  correspondientes a mi campus
                </ion-label>
                <span class="checkbox-container">
                  <ion-checkbox ngControl="termsAccepted" (ionChange)="onTermsChecked($event)"></ion-checkbox>
                </span>
              </ion-item>
            </div>
            <div *ngIf="driver">
              <ion-item>
                <ion-label position="floating">Pincode</ion-label>
                <ion-input name="pincode" type="password" formControlName="pincode"></ion-input>
              </ion-item>
            </div>
            <div *ngIf="errors">
              <p>{{errors}}</p>
            </div>
            <p *ngIf="!driver" (click)="goForgot()" tappable>¿Olvidaste contraseña?</p>
            <div>
              <ion-button
                shape="round"
                fill="outline"
                color="light"
                (click)="login()"
                [disabled]="form.invalid"
                expand="block"
                *ngIf="!driver"
              >
                Login
              </ion-button>
              <ion-button
                shape="round"
                fill="outline"
                color="light"
                (click)="login()"
                [disabled]="!form.controls.pincode.dirty || form.value.pincode == ''"
                expand="block"
                *ngIf="driver"
              >
                Login
              </ion-button>
            </div>
          </ion-col>
          <ion-col>
            <ion-col size="12" *ngIf="!driver && vm.mitec">
              <ion-button (click)="sso()" expand="block" color="light" shape="round" fill="solid">
                Soy Estudiante/Colaborador
              </ion-button>
            </ion-col>
            <p class="driver" (click)="driver=true" *ngIf="!driver">Soy conductor</p>
            <p class="driver" (click)="driver=false" *ngIf="driver">Soy usuario</p>
          </ion-col>
        </ion-row>
      </ion-grid>
    </form>
  </ion-content>
</ng-container>
